module.exports = __webpack_public_path__ + "img/full5-min.d62a7e32.png";